export class AuthConstants {
public static readonly AUTH = 'userData';
public static readonly PROPERTY = 'propertyData';
public static readonly SETTINGS = 'settingsData';
};
